module.exports = __webpack_public_path__ + "img/hall-hero-background.52588268.png";